import { cn } from '@/helpers/shadcn/utils'

const InfoItem = ({label, value, onClick, className}) => (
  <div>
    <div className="text-xs font-normal text-gray-50">{label}</div>
    <div 
      className={cn(
        "font-bold text-white text-sm",
        onClick && "cursor-pointer text-[#66A5E7]"
      )}
      onClick={onClick}
      style={{
        whiteSpace: 'normal',
        wordWrap: 'break-word',
      }}
    >
      <p className={cn('text-white pr-1', className)}>{value ?? '-'}</p>
    </div>
  </div>
)

export default InfoItem
